import { useMemo } from 'react';

import { useCheckoutProvider } from '#components/organisms/checkout/checkout-provider/useCheckoutProvider.js';
import { useUserData } from '@givebacks/api/core';
import { useShowConsumerCheckoutRequiredFields } from '@givebacks/api/store';
import { useFormListValidator } from 'core/Hooks';
import { DonorInfoForm } from 'ui';

const CheckoutUserInfoForm = () => {
  const { checkoutId, checkoutOrderSectionConfig } = useCheckoutProvider();
  const { data: user } = useUserData();
  const { data: requiredFields } = useShowConsumerCheckoutRequiredFields({
    checkoutId,
  });
  const formConfig = useMemo(() => {
    return checkoutOrderSectionConfig?.userInfoFormConfig;
  }, [checkoutOrderSectionConfig]);

  const initialValues = useMemo(() => {
    if (formConfig?.withInitialValues === false) return undefined;
    return {
      first_name: user?.first_name,
      last_name: user?.last_name,
      email: user?.email,
    };
  }, [formConfig?.withInitialValues, user?.email, user?.first_name, user?.last_name]);

  return (
    <DonorInfoForm
      id="donor_info"
      title={formConfig?.title ?? 'Your Information'}
      isPhoneNumberRequired={Boolean(requiredFields?.phone_number)}
      useFormListValidator={useFormListValidator}
      initialValues={initialValues}
      required
    />
  );
};

export { CheckoutUserInfoForm };
